/**
 * apps/web :: pass :: screens/passHome.routes
 *
 * Route descriptors for the W1.B pack-home + buy flow (ROADS-569).
 *
 * Wave 2 imports `passHomeRoutes` and pushes it into `PASS_ROUTES`
 * (`apps/web/src/pass/passRoutes.ts`). The `{ path: '' }` entry re-points
 * the `/pass` index from the W0.2 scaffold home to the real
 * `screens/PassHome` at that point.
 */
import type { PassRouteDescriptor } from "../routeDescriptor";
import PassHome from "./PassHome";
import PassStart from "./PassStart";

export const passHomeRoutes: PassRouteDescriptor[] = [
  { path: "", element: <PassHome /> }, // re-points the index in Wave 2
  { path: "start", element: <PassStart /> },
];
